import { CheckboxOptionType } from "antd"

import { MassPayoutsPageView } from "@src/pages/massPayouts/crypto"

export const enum MassPayoutPageVariants {
  Cards,
  Crypto,
}

export const MassPayoutRadioOptions: CheckboxOptionType<MassPayoutsPageView>[] =
  [
    {
      label: "CSV File",
      value: MassPayoutsPageView.UPLOAD,
    },
    {
      label: "Manual payouts",
      value: MassPayoutsPageView.MANUAL,
    },
  ]
